<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-card>
      <b-row>
        <b-col class="ml-5" style="text-align: left">
                      <span>
                        <font-awesome-icon v-if="row.item.detalleDatos.tieneSesiones" icon="check-circle"
                                           style="color: green"/>
                        <font-awesome-icon v-if="!row.item.detalleDatos.tieneSesiones" icon="times-circle"
                                           style="color: red"/>
                        Sesiones
                      </span> <br>
          <span>
                        <font-awesome-icon v-if="row.item.detalleDatos.tieneProgramados" icon="check-circle"
                                           style="color: green"/>
                        <font-awesome-icon v-if="!row.item.detalleDatos.tieneProgramados" icon="times-circle"
                                           style="color: red"/>
                        Tx programados
                      </span> <br>

          <span>
                        <font-awesome-icon v-if="row.item.detalleDatos.tieneRecibos" icon="check-circle"
                                           style="color: green"/>
                        <font-awesome-icon v-if="!row.item.detalleDatos.tieneRecibos" icon="times-circle"
                                           style="color: red"/>
                        Recibos
                      </span> <br>
          <span>
                        <font-awesome-icon v-if="row.item.detalleDatos.tienePagos" icon="check-circle"
                                           style="color: green"/>
                        <font-awesome-icon v-if="!row.item.detalleDatos.tienePagos" icon="times-circle"
                                           style="color: red"/>
                        Pagos
                      </span> <br>
          <span>
                    <font-awesome-icon v-if="row.item.detalleDatos.tieneFacturas" icon="check-circle"
                                       style="color: green"/>
                    <font-awesome-icon v-if="!row.item.detalleDatos.tieneFacturas" icon="times-circle"
                                       style="color: red"/>
                    Facturas
                  </span> <br>
          <span>
                    <font-awesome-icon v-if="row.item.detalleDatos.tieneCitas" icon="check-circle"
                                       style="color: green"/>
                    <font-awesome-icon v-if="!row.item.detalleDatos.tieneCitas" icon="times-circle" style="color: red"/>
                    Citas
                  </span> <br>
          <span>
                    <font-awesome-icon v-if="row.item.detalleDatos.tienePti" icon="check-circle" style="color: green"/>
                    <font-awesome-icon v-if="!row.item.detalleDatos.tienePti" icon="times-circle" style="color: red"/>
                    PTI
                  </span> <br>
          <span>
                    <font-awesome-icon v-if="row.item.detalleDatos.tieneHistoricos" icon="check-circle" style="color: green"/>
                    <font-awesome-icon v-if="!row.item.detalleDatos.tieneHistoricos" icon="times-circle" style="color: red"/>
                    PTI históricos
                  </span> <br>
          <span>
                    <font-awesome-icon v-if="row.item.detalleDatos.tieneHistoria" icon="check-circle"
                                       style="color: green"/>
                    <font-awesome-icon v-if="!row.item.detalleDatos.tieneHistoria" icon="times-circle"
                                       style="color: red"/>
                    Historia Clínica
                  </span>
          <div class="mt-4">
            <span><strong>Porcentaje de datos:</strong> </span><br>
            <b-progress height="2rem" :value="row.item.porcentajeDatos" show-progress class="mb-2"
                        animated></b-progress>
          </div>

        </b-col>
        <b-col cols="9">
          <b-card-header> Datos Fiscales</b-card-header>
          <b-table
              v-if="row.item.datosFiscales.length > 0"
              ref="tablaDatosFiscales"
              thead-tr-class="columnas"
              :items="row.item.datosFiscales"
              :fields="encabezadosDatosFiscales"
              class="parrafos"
              striped
              responsive
          >
            <template v-slot:cell(domicilioFiscal)="row">
                  <span>
                    {{ row.item.calle + ', ' + row.item.colonia + ', ' + row.item.estado }}
                  </span>
            </template>
          </b-table>

          <span v-else> NO HAY DATOS </span>
        </b-col>
      </b-row>
    </b-card>
  </div>

</template>

<script>
export default {
  name: "DetallePacienteUnificacion",
  props: {
    row: Array,
    encabezadosDatosFiscales: Array
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
}
</script>

<style scoped>

</style>
